import { render, staticRenderFns } from "./addLayerDialog.vue?vue&type=template&id=564ac7f4&scoped=true"
import script from "./addLayerDialog.vue?vue&type=script&lang=js"
export * from "./addLayerDialog.vue?vue&type=script&lang=js"
import style0 from "./addLayerDialog.vue?vue&type=style&index=0&id=564ac7f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ac7f4",
  null
  
)

export default component.exports